"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductPlacementCopyBox = void 0;
const tslib_1 = require("tslib");
const client_side_renderer_1 = require("@as-react/client-side-renderer");
const common_components_1 = require("@as-react/common-components");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const PPCUtil_1 = require("../../../util/PPCUtil");
const ProductPlacementCopyAPI_1 = tslib_1.__importDefault(require("../../../api/ProductPlacementCopyAPI"));
const logger_1 = require("@as-react/logger");
const index_1 = require("../../../index");
const EventUtil_1 = tslib_1.__importDefault(require("../../../util/EventUtil"));
const EventEnum_1 = require("../../../enums/EventEnum");
const YOUTUBE_SELECTOR = '.youtube-video';
const useProductPlacementCopyBox = (ppc) => {
    const { market, isInAuthorMode, rootWithLanguageSuffix, root } = (0, common_components_1.useAemConfig)();
    const [content, setContent] = (0, react_1.useState)(null);
    const renderedContainerElement = (0, react_1.useRef)(null);
    const { i18n } = (0, react_i18next_1.useTranslation)();
    const isExternal = () => ppc.text && ppc.text.indexOf('/') === 0;
    const isPPCHasVideo = () => { var _a; return (_a = renderedContainerElement === null || renderedContainerElement === void 0 ? void 0 : renderedContainerElement.current) === null || _a === void 0 ? void 0 : _a.querySelector(YOUTUBE_SELECTOR); };
    const PPCPositionTypes = (0, PPCUtil_1.getPPCPositionTypesByMarket)(market);
    const getContent = () => {
        if (isExternal()) {
            ProductPlacementCopyAPI_1.default.fetchPPC(ppc.text, isInAuthorMode ? `${rootWithLanguageSuffix}/` : root)
                .then(data => setContent(data))
                .catch(logger_1.Logger.logError);
        }
        else {
            setContent(ppc.text);
        }
    };
    const hydratePPCContentIfNeeded = () => {
        (0, client_side_renderer_1.renderReactComponentsInsideElementsIfNeeded)(index_1.availableComponents, renderedContainerElement.current, index_1.renderingTools, i18n)
            .then(() => isPPCHasVideo() && EventUtil_1.default.dispatch(EventEnum_1.EventEnum.NEW_VIDEO_IFRAME_ADDED))
            .catch(logger_1.Logger.logError);
    };
    (0, react_1.useEffect)(() => {
        getContent();
    }, [ppc]);
    (0, react_1.useEffect)(() => {
        if (content && renderedContainerElement && isExternal()) {
            hydratePPCContentIfNeeded();
        }
    }, [content, renderedContainerElement]);
    return {
        content,
        renderedContainerElement,
        PPCPositionTypes,
        isExternal,
    };
};
exports.useProductPlacementCopyBox = useProductPlacementCopyBox;
